import { createWebHistory, createRouter } from "vue-router";

import FormOnly from "./pages/FormOnly.vue";
import FormWithHeaderAndFooter from "./pages/FormWithHeaderAndFooter.vue";

const routes = [
  { name: "home", path: "/", component: FormWithHeaderAndFooter },
  { name: "form", path: "/form", component: FormOnly },
];

const baseUrl =
  process.env.NODE_ENV === "production"
    ? "PWelfareWeb/COMMON/invitation/consultform/"
    : "";
const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
});

export default router;
